// src/redux/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedIn: false,
  user: {},
  user_permissions: { permissions: {} },
  camera_details: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      const data = action.payload

      state.loggedIn = true;
      state.user = data.user;
      state.camera_details = data.camera_details
      const navigate = data.navigate
      localStorage.setItem("loggedIn", "true");
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("camera_details", JSON.stringify(data.camera_details));

      localStorage.setItem("accessToken", data?.access);
      localStorage.setItem("refreshToken", data?.refresh);
      navigate('/')
    },
    logout: (state, action) => {

      const navigate = action.payload

      state.loggedIn = false;
      state.user = null;
      localStorage.removeItem('loggedIn')
      localStorage.removeItem('user')
      localStorage.removeItem('camera_details')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('accessToken')
      navigate('/login')
    },
    setAuthFromStorage: (state) => {
      const loggedIn = localStorage.getItem("loggedIn") === "true";
      const user = JSON.parse(localStorage.getItem("user"));
      const cameraData = localStorage.getItem("camera_details")
      const camera_details = cameraData ? JSON.parse(cameraData) : [];

      state.loggedIn = loggedIn;
      state.user = user;
      state.camera_details = camera_details
    },
  },
});

export const { login, logout, setAuthFromStorage } = authSlice.actions;
export default authSlice.reducer;
